// interface QRItem {
//   id: string | number;
//   item_number: string;
//   product?: any;
//   type?: string;
//   specifications?: any;
//   dimensions?: any;
//   color?: string;
// }

// interface QRLayoutParams {
//   allItems: QRItem[];
//   qrCodeImages: Record<string | number, string>;
//   qrData?: any;
//   order?: any;
// }

// export const generateQRLayout = ({ allItems, qrCodeImages, qrData, order }: QRLayoutParams): string => {
//   return allItems.map(item => {
//     const width = item.width || item.specifications?.width || item.product?.width || item.dimensions?.width;
//     const height = item.height || item.specifications?.height || item.product?.height || item.dimensions?.height;
//     const color =
//       item.color ||
//       item.specifications?.color ||
//       item.specifications?.colour ||
//       item.product?.color ||
//       item.product?.colour ||
//       '-';

//     return `
//       <div class="qr-item">
//         <div class="qr-code">
//           ${
//             qrCodeImages[item.id]
//               ? `<img src="${qrCodeImages[item.id]}" alt="QR Code" />`
//               : '<div style="width: 16mm; height: 16mm; background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 5px;">Loading...</div>'
//           }
//         </div>
//         <div class="item-details">
//           <div class="item-title">${item.item_number}</div>
//           <div>${qrData?.order?.customer_name || order?.customer?.name || '-'}</div>
//           <div>${item?.product?.type || '-'} - ${item.type || '-'}</div>
//           <div>${item.product?.name || item.product?.type || '-'}</div>
//           <div>${width && height ? `${Math.round(width)} W x ${Math.round(height)} H` : '-'}</div>
//           <div>${color}</div>
//         </div>
//       </div>
//     `;
//   }).join('');
// };
import { formatStatusText,capitalizeWords } from './formatters'

interface QRItem {
  id: string | number;
  item_number?: string; // Legacy snake_case
  itemNumber?: string; // camelCase from backend
  product?: any;
  type?: string;
  specifications?: any;
  dimensions?: any;
  color?: string;
  width?: number | string;
  height?: number | string;
}

interface WorkerQRData {
  id: string | number;
  first_name?: string;
  last_name?: string;
  email?: string;
  employee_id?: string;
  role?: string;
  branch?: {
    id: string;
    name: string;
  };
  stages?: string[];
}

const stages = [
  "Cutting",
  "Welding",
  "Grinding",
  "Polishing",
  "Painting",
  "Packing"
];

interface QRLayoutParams {
  allItems?: QRItem[]; // optional array
  singleItem?: QRItem; // optional single
  qrCodeImages: Record<string | number, string>;
  qrData?: any;
  order?: any;
}

interface WorkerQRLayoutParams {
  worker: WorkerQRData;
  qrCodeImages: Record<string | number, string>;
  qrData?: any;
}

export const generateWorkerQRLayout = ({
  worker,
  qrCodeImages,
  qrData,
}: WorkerQRLayoutParams): string => {
  const workerName = `${worker.firstName || ''} ${worker.lastName || ''}`.trim() || worker.employeeId || 'N/A';

  const stagesHtml = worker.stages && worker.stages.length > 0
    ? (() => {
        const visibleStages = worker.stages.slice(0, 5);
        const stagesText = visibleStages.map((stage, i) =>
          `${stage && typeof stage === 'object' && stage.name ? stage.name : (stage || '')}${i < visibleStages.length - 1 ? ', ' : ''}`
        ).join('');
        const moreText = worker.stages.length > 5 ? ` +${worker.stages.length - 5} more` : '';
        return `<div style="font-size: 8px; color: #aaa; opacity: 0.85;">${stagesText}</div>`;
      })()
    : '';

    console.log('Generating QR for qrCodeImages:', qrCodeImages);
    console.log('Generating QR for worker:', worker);
    console.log('Generating QR for wworkerName:', workerName);

    return `
    
       <div class="qr-item">
          <div class="qr-code">
         
               ${
              qrCodeImages[worker.id]
                ? `<img src="${qrCodeImages[worker.id]}" alt="QR Code" />`
                : '<div style="width: 16mm; height: 16mm; background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 5px;">Loading...</div>'
            }

           
          </div>
          <div class="item-details">
            <div class="item-title" style="font-weight: 700"> ${capitalizeWords(workerName)}</div>
            
            ${stagesHtml}
          </div>
        </div>
        `

  // return `
  //   <div class="qr-item">
  //     <div class="qr-code">
  //       ${
  //         qrCodeImages[worker.id]
  //           ? `<img src="${qrCodeImages[worker.id]}" alt="QR Code" style="width: 80px; height: 80px;" />`
  //           : '<div style="width: 16mm; height: 16mm; background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 5px;">Loading...</div>'
  //       }
  //     </div>

  //     <div class="ma" style="flex-grow: 1; text-align: left; line-height: 1.2;">
  //       <div style="font-size: 10px; font-weight: 600; color: #222; margin-bottom: 2px;">
  //         ${capitalizeWords(workerName)}
  //       </div>
  //       ${stagesHtml}
  //     </div>
  //   </div>
  // `;
};

export const generateQRLayout = ({
  allItems,
  singleItem,
  qrCodeImages,
  qrData,
  order,
}: QRLayoutParams): string => {
  const items = allItems ?? (singleItem ? [singleItem] : []);
  if (!items.length) return "<p>No items to print</p>";

  return items
    .map((item) => {
      const width =
        item.width ||
        item.specifications?.width ||
        item.product?.width ||
        item.dimensions?.width;
      const height =
        item.height ||
        item.specifications?.height ||
        item.product?.height ||
        item.dimensions?.height;
      const color =
        item.color ||
        item.specifications?.color ||
        item.specifications?.colour ||
        item.product?.color ||
        item.product?.colour ||
        "-";

      return `
        <div class="qr-item">
          <div class="qr-code">
            ${
              qrCodeImages[item.id]
                ? `<img src="${qrCodeImages[item.id]}" alt="QR Code" />`
                : '<div style="width: 16mm; height: 16mm; background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 5px;">Loading...</div>'
            }
          </div>
          <div class="item-details">
            <div class="item-title" style="font-weight: 700">${(item as any).itemNumber || item.item_number || "-"}</div>
            <div style="font-weight: 700">${qrData?.order?.siteNamePlate || qrData?.order?.site_name_plate || "-"}</div>
            <div style="font-weight: 700">${capitalizeWords(item?.product?.type) || "-"} - ${capitalizeWords(item.type) || "-"}</div>
            <div style="font-weight: 700">${capitalizeWords(item.product?.name) || capitalizeWords(item.product?.type) || "-"}</div>
            <div style="font-weight: 700">${
              width && height ? `${Math.round(Number(width))} w x ${Math.round(Number(height))} h` : "-"
            }</div>
            <div style="font-weight: 700">${formatStatusText(color)}</div>
          </div>
        </div>
      `;
    })
    .join("");
};
